<div class="login_type">
  <h2 class="login_type__question">{{ 'PAGES.AUTH.LOGIN_FLOW_TYPE.QUESTION' | translate }}</h2>
  <p class="login_type__info">{{ 'PAGES.AUTH.LOGIN_FLOW_TYPE.QUESTION.INFO' | translate }}</p>

  <div class="login_type__question__options">
    <button mm-button class="login_type__magic" color="primary" (click)="onMagicLoginClick()">
      {{ 'PAGES.AUTH.LOGIN_FLOW_TYPE.QUESTION.PASSWORDLESS' | translate }}
    </button>
    <button
      mm-button
      class="login_type__password"
      color="primary"
      (click)="onPasswordLoginClick()"
      test-target="login_type__password"
    >
      {{ 'PAGES.AUTH.LOGIN_FLOW_TYPE.QUESTION.PASSWORD' | translate }}
    </button>
  </div>
</div>
